// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"930e2ba7","381":"e9637e6f","774":"3ce10bc6","820":"e8237b38","851":"09b87859","883":"54942e55"}[chunkId] + ".chunk.js";
};